const StepInstructionDefaultStyle = {
    styleType: "step_instruction_menu",
    guiText: "Step Instruction Menu",
    name: "Default-Step-Menu",
    backgroundColor: {r: 236, g: 236, b: 236, a: 1.0},
    buttonBackgroundColor: {r: 223, g: 223, b: 223, a: 1.0},
    buttonHoverColor: {r: 177, g: 212, b: 233, a: 1},
    accentColor: {r: 50, g: 128, b: 177, a: 1},
    textColor: {r: 0, g: 0, b: 0, a: 1},
    alias: "Styles/Default-Step-Menu",
    type: "Style",
    opacity: 0.7,
    buttons: [
        {name: "Button 1", icon: "$home"},
        {name: "Button 2", icon: ""},
        {name: "Button 3", icon: ""},
        {name: "Button 4", icon: "$back"},
        {name: "Button 5", icon: "$forward"}
    ],
    titleText: "Default Title",
    subTitleText: "Text Box Text Box Text Box Text Box Text Box",
};

module.exports = {
    StepInstructionDefaultStyle
};
